export default "__VITE_ASSET__22ca45be__"